import { SmartyStreetsAddress } from '../../generic/address-autocomplete/address-autocomplete.component';

export const addressToString = (a: SmartyStreetsAddress) => {
  const secondary = a.secondary ? `, ${a.secondary}` : '';

  return `${a.street_line}${secondary}, ${a.city}, ${a.state} ${a.zipcode}`;
};
